import {
  GET_AVAILABLE_DATA_FEEDS_SUCCESS,
  GET_AVAILABLE_DATA_FEEDS_FAILURE,
} from '../../../../../store/actionTypes';

/**
 * initial state data
 */
const initialState: any = {
  availableFeeds: [],
  error: false,
  loading: true,
};

/**
 * Reducer for managing the Available Feed Data
 * @param state
 * @param action
 * @returns state
 */
const availableDataFeedReducer = (state = initialState, action: any): any => {
  let payload: any;
  const data = action.data && action.data.data;
  switch (action.type) {
    case GET_AVAILABLE_DATA_FEEDS_SUCCESS:
      payload = Object.assign([], data);
      return { ...state, availableFeeds: payload, loading: false };
    case GET_AVAILABLE_DATA_FEEDS_FAILURE:
      return { ...state, error: true, loading: false };
    default:
      return {
        ...state,
      };
  }
};
export default availableDataFeedReducer;
